
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.18 9.092l-.007.563 6.782 3.39 3.39 6.783.563-.008L19.971.445l-.244-.17-.172-.245L.18 9.092zm18.03-7.743L7.125 12.432 1.03 9.384 18.21 1.35zM10.615 18.97l-3.048-6.096L18.65 1.791 10.616 18.97z"}})])
          )
        }
      }
    